import { render, staticRenderFns } from "./editTerm.vue?vue&type=template&id=77d71dc4&"
import script from "./editTerm.vue?vue&type=script&lang=js&"
export * from "./editTerm.vue?vue&type=script&lang=js&"
import style0 from "./editTerm.vue?vue&type=style&index=0&id=77d71dc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports